module.exports = __webpack_public_path__ + "static/media/logo.c44c0f9a.png";